/*
 *
 * Cart constants
 *
 */

export const TOGGLE_CART = 'src/Cart/TOGGLE_CART';
export const ADD_TO_CART = 'src/Cart/ADD_TO_CART';
export const REMOVE_FROM_CART = 'src/Cart/REMOVE_FROM_CART';
export const UPDATE_CART_ITEM = 'src/Cart/UPDATE_CART_ITEM';
export const CLEAR_CART = 'src/Cart/CLEAR_CART';
export const SET_CART_ITEMS = 'src/Cart/SET_CART_ITEMS';
export const CART_LOADING = 'src/Cart/CART_LOADING';
export const HANDLE_CART_TOTAL = 'src/Cart/HANDLE_CART_TOTAL';
export const SET_CART_ID = 'src/Cart/SET_CART_ID';
export const CART_ERROR = 'src/Cart/CART_ERROR';

export const CART_ID = 'cart_id';
export const SELECTED_TICKETS = 'src/Cart/SELECTED_TICKETS';
export const DELETE_SELECTED_TICKETS = 'src/Cart/DELETE_SELECTED_TICKETS';
export const SET_GUEST_INFO = 'src/Cart/SET_GUEST_INFO';
export const SHOW_GUEST_FORM = 'src/Cart/SHOW_GUEST_FORM';
export const SET_GUEST_FORM_ERRORS = 'src/Cart/SET_GUEST_FORM_ERRORS';
export const SET_CART_COUPON = 'src/Cart/SET_CART_COUPON';
export const APPLY_COUPON_TO_CART = 'src/Cart/APPLY_COUPON_TO_CART';
export const ADD_PRODUCT_TO_CART = 'src/Cart/ADD_PRODUCT_TO_CART';
export const SELECTED_PRODUCTS = 'src/Cart/SELECTED_PRODUCTS';
export const DELETE_SELECTED_PRODUCTS = 'src/Cart/DELETE_SELECTED_PRODUCTS';
